import React from 'react'
import { arrayOf, string, shape, number, bool } from 'prop-types'
import { Flex, Heading, Text, Box } from 'rebass'
import citygateTheme from '../../theme/'
import NumberFormat from 'react-number-format'
import typography from '../../utils/typography'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import LinkRounded from '../../components/LinkRounded'
import ContentBrandDerivativeSpecDetail from '../../components/ContentBrandDerivativeSpecDetail'
import ContentModalHowCanWeHelp from '../ContentModalHowCanWeHelp'

import {
  SpecBreakout,
  CenterCta,
  CtaLink,
  SpecDetail,
  TabWrapper,
  BasicLink,
  FlexWrapper,
  ArrowRight
} from './components/Spec'

const specFields = [
  { field: 'doors', label: 'Size and Space', suffix: 'Doors', decimal: false },
  {
    field: 'engineSize',
    label: 'Engine',
    dataSuffix: 'transmission',
    decimal: true
  },

  {
    field: 'batterySize',
    label: 'Battery Size',
    dataSuffix: 'batteryUnits',
    lowerData: true,
    decimal: false
  },

  { field: 'range', label: 'Range', suffix: 'Miles', decimal: false },

  {
    field: 'rapidCharging',
    label: 'Rapid Charging',
    suffix: 'Minutes',
    decimal: false
  },

  { field: 'efficiency', label: 'Efficiency', suffix: 'MPG', decimal: true },

  {
    label: 'Performance',
    field: 'performance',
    suffix: 'PS',
    decimal: false
  }
]

const extractInterestingFigures = (spec) => {
  const fields = specFields.map((specItem) => ({
    ...specItem,
    value: spec[specItem.field],
    suffix: specItem.dataSuffix ? spec[specItem.dataSuffix] : specItem.suffix
  }))

  return fields.filter((field) => !!field.value)
}

class ContentBrandDerivativeSpec extends React.PureComponent {
  constructor(props) {
    super(props)
    this.myCountUp = null
    this.state = {
      tabIndex: 0,
      isBookTestDriveOpen: this.props.isBookTestDriveOpen,
      isAskQuestionOpen: this.props.isAskQuestionOpen,
      isEnquiryOpen: this.props.isTestDriveOpen || this.props.isAskQuestionOpen
    }
    this.handleAskQuestion = this.handleAskQuestion.bind(this)
    this.handleAskQuestionClose = this.handleAskQuestionClose.bind(this)
    this.handleBookTestDrive = this.handleBookTestDrive.bind(this)
    this.handleBookTestDriveClose = this.handleBookTestDriveClose.bind(this)
    this.handleEnquiry = this.handleEnquiry.bind(this)
    this.handleEnquiryClose = this.handleEnquiryClose.bind(this)
  }

  handleEnquiry(e) {
    e.preventDefault()
    this.setState({ isEnquiryOpen: true })
  }

  handleEnquiryClose() {
    this.setState({
      isEnquiryOpen: false,
      isAskQuestionOpen: false,
      isTestDriveOpen: false
    })
  }

  handleBookTestDrive() {
    this.setState({ isTestDriveOpen: true, isEnquiryOpen: true })
  }

  handleBookTestDriveClose() {
    this.setState({ isTestDriveOpen: false })
  }

  handleAskQuestion(e) {
    e.preventDefault()
    this.setState({ isAskQuestionOpen: true, isEnquiryOpen: true })
  }

  handleAskQuestionClose() {
    this.setState({ isAskQuestionOpen: false })
  }

  render() {
    return (
      <>
        <TabWrapper mx={'8%'} bg={citygateTheme.colors.blue}>
          <Heading mb={50} fontSize={[5, 6, 7]}>
            {this.props.specifications.length === 1
              ? 'Available Spec'
              : 'Choose your spec below'}
          </Heading>
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.setState({ tabIndex })}
          >
            <FlexWrapper flexWrap="wrap">
              <TabList>
                {this.props.specifications.map((spec, key) => (
                  <Tab key={`bdspec:${key}:${spec.label}`}>
                    <BasicLink>{spec.name}</BasicLink>
                  </Tab>
                ))}
              </TabList>
            </FlexWrapper>
            {this.props.specifications.map((spec, key) => (
              <TabPanel key={`tpbds:${key}:${spec.name}`}>
                <Flex
                  flexWrap="wrap"
                  py={[typography.rhythm(2), null, typography.rhythm(2.5)]}
                >
                  <SpecDetail
                    width={[12 / 12, null, 6 / 12]}
                    mx={['auto', null, 'initial']}
                  >
                    <Heading as="h2" fontSize={7}>
                      {spec.label}
                    </Heading>
                    {spec.price && (
                      <Text
                        as="span"
                        fontSize={5}
                        color={citygateTheme.colors.blue_light_op50}
                        bold
                      >
                        From{' '}
                        <NumberFormat
                          value={spec.price}
                          displayType={'text'}
                          thousandSeparator
                          prefix={this.props.currency.symbol}
                        />
                      </Text>
                    )}
                    {spec.description && (
                      <Text
                        mt={typography.rhythm(0.5)}
                        mb={[
                          typography.rhythm(1.5),
                          null,
                          typography.rhythm(2)
                        ]}
                      >
                        {spec.description}
                      </Text>
                    )}
                    {!spec.description && (
                      <Text
                        mt={typography.rhythm(0.5)}
                        mb={[typography.rhythm(0.5)]}
                      />
                    )}
                    <CenterCta>
                      <LinkRounded
                        onClick={this.handleBookTestDrive}
                        reversed
                        shadow
                      >
                        Register Interest
                      </LinkRounded>
                      <Box onClick={this.handleAskQuestion} flex="1 1 auto">
                        <CtaLink hrefontSize="javascript:void(0);">
                          <ArrowRight />
                          <span>Ask us anything else</span>
                        </CtaLink>
                      </Box>
                    </CenterCta>
                  </SpecDetail>
                  <SpecBreakout width={[1 / 1, null, 5 / 12]} ml="auto">
                    <Flex flexWrap="wrap">
                      <ContentBrandDerivativeSpecDetail
                        key={`tpcbdsd:${key}:${spec.name}`}
                        spec={
                          spec.images && spec.images.length > 0
                            ? [{ image: spec.images[0] }]
                            : extractInterestingFigures(spec)
                        }
                      />
                    </Flex>
                  </SpecBreakout>
                </Flex>
              </TabPanel>
            ))}
          </Tabs>
        </TabWrapper>
        <ContentModalHowCanWeHelp
          open={this.state.isEnquiryOpen}
          onClose={this.handleEnquiryClose}
          vehicleId={this.props.vehicleId}
          locations={this.props.locations}
          isTestDriveOpen={this.state.isTestDriveOpen}
          onTestDriveClose={this.handleBookTestDriveClose}
          location={this.props.location && this.props.location.shortName}
          registration={this.props.registration}
          isAskQuestionOpen={this.state.isAskQuestionOpen}
          onAskQuestionClose={this.handleAskQuestionClose}
          brandSpecific={this.props.brandSpecific}
          brand={this.props.brand}
          model={this.props.model}
          locationInfo={this.props.location}
          isNewVehicle={this.props.isNewVehicle}
        />
      </>
    )
  }
}

ContentBrandDerivativeSpec.defaultProps = {
  specifications: [],
  currency: { code: 'GBP', symbol: '£' },
  make: { shortName: '', name: '' }
}

ContentBrandDerivativeSpec.propTypes = {
  specifications: arrayOf(
    shape({
      name: string,
      label: string,
      price: string,
      description: string,
      doors: number,
      engineSize: number,
      transmission: string,
      efficiency: number,
      performance: number
    })
  ),
  currency: shape({ code: string, symbol: string }),
  brandSpecific: bool,
  brand: string
}

export default ContentBrandDerivativeSpec
